import { render, staticRenderFns } from "./shipmentListCreate.pug?vue&type=template&id=282222a2&lang=pug&"
import script from "./shipmentListCreate.ts?vue&type=script&lang=ts&"
export * from "./shipmentListCreate.ts?vue&type=script&lang=ts&"
import style0 from "./shipmentListCreate.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports